import { StyleSheet } from 'aphrodite';
import { brandPrimaryHover, navigation, titles } from '../../styles/colors';
import { BreakPoints } from '../../styles/styles';

// tslint:disable:object-literal-key-quotes

export const styleSheet = StyleSheet.create({
	backgroundBlue: {
		backgroundSize: 'contain',
		position: 'absolute',
		width: '100%',
		zIndex: -1,
		// tslint:disable-next-line: object-literal-sort-keys
		'@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)': {
			height: '100%',
			maxHeight: 'none',
			width: '100vw',
		},
	},
	bgSVG: {
		height: '800px',
		width: '100%',
	},
	buttonSuccessText: {
		paddingRight: 10,
	},
	displaySection: {
		display: 'flex',
		margin: '60px auto',
		maxWidth: 1200,
		[BreakPoints.forMaxWith(1150)]: {
			display: 'block',
		},
	},
	displaySectionLeft: {
		width: '70%',
		[BreakPoints.forMaxWith(1150)]: {
			width: '100%',
		},
	},
	displaySectionRight: {
		maxWidth: 360,
		minWidth: 340,
		width: '30%',
		[BreakPoints.forMaxWith(1150)]: {
			margin: '0 auto',
			width: '100%',
		},
	},
	displayTitle: {
		fontSize: 24,
		fontWeight: 600,
		margin: '40px 0',
	},
	integration: {
		backgroundSize: 'contain',
		margin: 50,
		width: 180,
	},
	integrationContainer: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'space-around',
		margin: '0 auto',
		marginBottom: 50,
	},
	integrationSection: {
		margin: '0 auto',
		maxWidth: 1200,
	},
	integrationTitle: {
		color: navigation,
		fontSize: 24,
		margin: '40px auto 0',
		textAlign: 'center',
	},
	largeQuote: {
		color: brandPrimaryHover,
		fontSize: 24,
		fontWeight: 'normal',
		margin: 0,
		paddingTop: 10,
		textAlign: 'center',
	},
	logoContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		maxWidth: '100%',
		paddingBottom: 20,
		paddingTop: 50,
	},
	logoSVG: {
		height: 'auto',
		maxWidth: 320,
		width: '100%',
	},
	mcafee: {
		margin: '10px 0 0 10px',
		width: 100,
	},
	name: {
		color: titles,
		fontSize: 14,
		margin: 5,
		textAlign: 'center',
		// tslint:disable-next-line: object-literal-sort-keys
		':first-of-type': {
			marginTop: 10,
		},
	},
	orangeBar: {
		backgroundColor: '#F89143',
		borderTopLeftRadius: 10,
		borderTopRightRadius: 10,
		height: 10,
	},
	requestAnswer: {
		alignItems: 'center',
		backgroundColor: '#F9F9F9',
		border: '1px solid #F89143',
		borderRadius: 8,
		color: navigation,
		display: 'flex',
		fontSize: 18,
		fontWeight: 'bold',
		height: 50,
		justifyContent: 'center',
		padding: '10px',
		textAlign: 'center',
		textTransform: 'uppercase',
		width: '100%',
	},
	requestButton: {
		backgroundColor: '#F89143',
		borderRadius: 8,
		boxShadow: '0 0 6px 0 rgba(124,124,124, 0.2)',
		color: 'white',
		fontSize: 18,
		fontWeight: 'bold',
		height: 50,
		padding: '10px',
		textAlign: 'center',
		textTransform: 'uppercase',
		width: '100%',
		// tslint:disable-next-line: object-literal-sort-keys
		':active': {
			backgroundColor: '#CD7736',
		},
	},
	signUp: {
		background: '#F9F9F9',
		borderRadius: 10,
		boxShadow: '0 0 6px 0 rgba(124,124,124, 0.2)',
		color: titles,
		marginTop: 100,
		maxWidth: 360,
		minWidth: 340,
		transform: 'translateX(-20px)',
		[BreakPoints.forMaxWith(1150)]: {
			margin: '40px auto 10px',
			maxWidth: '90%',
			transform: 'translateX(0px)',
			width: '400px',
		},
	},
	signUpContentContainer: {
		padding: 40,
	},
	signUpTitle: {
		fontSize: 24,
		fontWeight: 600,
		margin: 0,
	},
	smallQuote: {
		color: brandPrimaryHover,
		fontSize: 18,
		fontWeight: 'normal',
		margin: 0,
		textAlign: 'center',
	},
	subTitle: {
		color: '#FFF',
		display: 'block',
		fontSize: 20,
		fontWeight: 'normal',
		margin: '30px auto',
		textAlign: 'center',
		width: '50%',
		[BreakPoints.forMaxWith(1150)]: {
			width: '60%',
		},
	},
	termsAgreement: {
		color: navigation,
		fontSize: 12,
		margin: '10px auto',
		width: '90%',
	},
	testimonial: {
		alignItems: 'flex-start',
		display: 'flex',
		justifyContent: 'space-between',
		margin: '60px auto',
		maxWidth: 1000,
	},
	testimonialContainer: {
		margin: '0 auto',
		width: '70%',
		[BreakPoints.forMaxWith(1150)]: {
			width: '100%',
		},
	},
	testimonialContent: {
		width: '60%',
		[BreakPoints.forMaxWith(1150)]: {
			width: '80%',
		},
	},
	testimonialSection: {
		backgroundColor: '#E8F3F9',
		margin: '0 auto',
		padding: 50,
	},
	testimonialTitle: {
		fontSize: 24,
		fontWeight: 'normal',
		textAlign: 'center',
	},
	title: {
		color: '#FFF',
		fontSize: 32,
		fontWeight: 'normal',
		margin: '20px 40px 0px',
		textAlign: 'center',
	},
	trialContainer: {
		minHeight: '100vh',
		overflowX: 'hidden',
		width: '100%',
	},
	trialContentContainer: {
		margin: '0 auto',
	},
	useCaseItem: {
		alignItems: 'center',
		display: 'flex',
		// tslint:disable-next-line: object-literal-sort-keys
		':first-of-type': {
			marginTop: 20,
		},
	},
	useCaseSection: {
		margin: '0 auto',
		width: '70%',
	},
	useCaseText: {
		marginLeft: 20,
	},
	webMobileDisplay: {
		backgroundSize: 'cover',
		margin: '20px auto',
		width: '100%',
		[BreakPoints.forMaxWith(1150)]: {
			display: 'block',
			maxWidth: '90%',
		},
	},
});
